<div class="modal-header" [ngClass]="{ 'preview-reply-attachment': reply }">
    <div class="name-wrapper">
        @if (!reply) {
            <div class="attachment-name">{{ currentAttachment.name }}</div>
        } @else {
            <div class="d-flex flex-row justify-content-start align-items-center">
                <sb-user-avatar [user]="reply.author"></sb-user-avatar>
                <div class="d-flex flex-column w-100" style="max-width: calc(100% - 40px)">
                    <div class="attachment-name">{{ currentAttachment.name || 'no name' | translate }}</div>
                    <small class="text-light text-break">
                        {{ reply.author.name || reply.author.email }}
                        {{ reply.creationTime | date: 'dd.MM.yyyy HH:mm' }}
                    </small>
                </div>
            </div>
        }
    </div>
    <div class="d-flex align-items-center btn-row">
        @if (reply && currentAttachment.isPrintingAvailable) {
            <button
                (click)="$event.stopPropagation(); printService.printAttachment(currentAttachment.url)"
                class="btn btn-icon btn-transparent btn-file-action"
                [attr.aria-label]="'Print file' | translate"
                tooltip="{{ 'Print' | translate }}">
                <sb-inline-svg class="icon pointer" [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/print.svg'">
                </sb-inline-svg>
            </button>
        }
        @if (currentAttachment.isDownloadAvailable) {
            <a
                class="btn btn-icon btn-transparent btn-file-action link"
                tooltip="{{ 'Download' | translate }}"
                [attr.aria-label]="'Download file' | translate"
                [href]="currentAttachment.url"
                target="_blank"
                download="{{ currentAttachment.name }}">
                <sb-inline-svg
                    class="icon"
                    [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/Download icon.svg'"
                    (click)="$event.stopPropagation()">
                </sb-inline-svg>
            </a>
        }
        @if (reply && isForwardAllowed) {
            <button
                class="btn btn-icon btn-transparent btn-file-action"
                [attr.aria-label]="'Forward file' | translate"
                (click)="forwardFile()"
                tooltip="{{ 'Forward file' | translate }}">
                <sb-inline-svg
                    class="icon"
                    [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/Wide arrow.svg'"></sb-inline-svg>
            </button>
        }

        <div class="vertical-divider"></div>

        <button
            type="button"
            class="btn btn-icon btn-close btn-transparent"
            [attr.aria-label]="'Close' | translate"
            (click)="decline()">
            <sb-inline-svg class="icon icon-close" [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
            </sb-inline-svg>
        </button>
    </div>
</div>
<div class="modal-body position-relative" (click)="onModalBodyClick()">
    @if (isCarouselEnabled && !(fileIndex === 0)) {
        <a
            role="button"
            class="left carousel-button"
            [attr.aria-label]="'Previous' | translate"
            (click)="toggleFileView(-1); $event.stopPropagation()">
            <sb-inline-svg
                class="icon pointer"
                [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/Arrow left icon.svg'">
            </sb-inline-svg>
        </a>
    }

    <sb-file-view
        [attachment]="currentAttachment"
        [isFilePreviewInMessage]="isFilePreviewInMessage"
        [isRoundedCorners]="false"
        [permalink]="permalink"
        [isZoomAvailable]="true"
        style="padding: 20px 50px"></sb-file-view>

    @if (isCarouselEnabled && !(fileIndex === attachments.length - 1)) {
        <a
            role="button"
            [attr.aria-label]="'Next' | translate"
            class="right carousel-button"
            (click)="toggleFileView(1); $event.stopPropagation()">
            <sb-inline-svg
                class="icon pointer"
                [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/Arrow right icon.svg'">
            </sb-inline-svg>
        </a>
    }
</div>
@if (isForwarding) {
    <bs-modal-backdrop class="modal-backdrop in show"></bs-modal-backdrop>
}
